<template>
<div>
  <el-row type="flex" class="title-bar" justify="space-between">
    <div class="vertical-center-box">
      <div class="title-h3 mr-r10">
        스냅샷
      </div>
      <el-radio-group class="mr-r4" v-model="dumpType" @change="changeDumpType">
        <el-radio-button label="fileDump">파일</el-radio-button>
        <el-radio-button label="heapDump">힙</el-radio-button>
      </el-radio-group>
      <el-button class="mr-l4" size="mini" @click="loadData"><i class="far fa-sync-alt"/></el-button>
    </div>
    <div>
      <el-button size="small" @click="exportSnapshotInfo"><img src="@/assets/img/icons/excel.png" style="position:relative;top:3px;left:-2px">  엑셀출력</el-button>
    </div>
  </el-row>
  <hr class="mr-b20">
  <div>
    <el-row type="flex" class="title-bar" justify="space-between">
      <div v-show="dumpType === 'fileDump'" class="vertical-center-box">
        <div class="title-h4 mr-r4">파일 스냅샷 리스트</div>
        <el-button class="mr-r4" @click.native="executeDump('active', '액티브리스트 스냅샷')">액티브리스트</el-button>
        <el-button class="mr-r4" @click.native="executeDump('thread', '쓰레드 스냅샷')">쓰레드</el-button>
        <el-button class="mr-r4" @click.native="executeDump('threadList', '쓰레드리스트 스냅샷')">쓰레드리스트</el-button>
        <el-button  @click.native="executeDump('heaphisto', '힙 히스토그램 스냅샷')">힙 히스토그램</el-button>
      </div>
      <div v-show="dumpType === 'heapDump'" class="vertical-center-box">
        <div class="title-h4 mr-r4">힙 덤프 리스트</div>
        <el-button  @click="onClickHeapDump">힙 덤프</el-button>
      </div>
      <div>
        <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
      </div>
    </el-row>
    <el-table-wrapper v-show="dumpType === 'fileDump'" ref="dumpListView" v-loading="isLoading" :data="tableData" :column-default="columnDefault" :columns="columns"
    :pagination="true" @current-change="currentRowChange" :defaultSort="defaultSortCol"
     :show-custom-header="true" :show-search-tool="showSearchTool" :total="totalData" style="width:100%;">
     <template slot-scope="scope" slot="detail-slot">
      <span v-if="checkSize(scope.row.size)" class="c-pointer"><i class="far fa-search-plus" @click="openfileDumpPopup(scope.row)"/></span>
      </template>
    </el-table-wrapper>
    <el-table-wrapper v-show="dumpType === 'heapDump'" ref="heapDumpListView" v-loading="isLoading" :data="tableData" :column-default="columnDefault" :columns="heapColumns"
    :pagination="true" highlight-current-row  @current-change="currentRowChange"
     :show-custom-header="true" :show-search-tool="showSearchTool" :total="totalData" style="width:100%;">
     <template v-if="checkSize(scope.row.size)" slot-scope="scope" slot="download-slot">
       <i class="fas fa-download c-pointer" @click="dumpDownLoad(scope.row)"></i>
     </template>
     <template slot-scope="scope" slot="delete-slot">
       <i class="far fa-trash-alt c-pointer" @click="dumpDelete(scope.row)"></i>
     </template>
    </el-table-wrapper>
  </div>
  <w-file-dump-popup ref="fileDumpPopup" :fileDumpParams="fileDumpParams"></w-file-dump-popup>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { cloneDeep, isNil, isEmpty } from 'lodash';
import moment from 'moment';
import { convertValuByUnit } from '@/utils/number';
import { columnDefault } from '@/constants/table';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import ApmConfigAPI from '@/api/config/apm/apm-info';
import msgUtil from '@/utils/message';
import FileApi from '@/api/common/file';
import WFileDumpPopup from './popup/FileDumpPopup';

export default {
  name: 'WSnapshotInfoNode',
  components: {
    WFileDumpPopup,
  },
  props: {
    activeTab: {
      type: String,
    },
  },
  data() {
    return {
      columnDefault,
      fileDumpParams: {},
      tableData: [],
      totalData: 0,
      defaultSortCol: { prop: 'last_modified', order: 'descending' },
      showSearchTool: false,
      isLoading: false,
      selectionRow: null,
      dumpType: 'fileDump',
      params: {
        objId: null,
      },
      columns: [
        {
          prop: 'name',
          label: '파일 이름',
          width: 700,
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'size',
          label: '파일 크기(byte)',
          sortable: true,
          searchable: false,
          formatter: this.getConvertSizeByBData,
        },
        {
          prop: 'last_modified',
          label: '마지막 생성시각',
          searchType: 'date',
          sortable: true,
          searchable: true,
          formatter: this.dateFormmater,
        },
        {
          label: '상세보기',
          width: 80,
          scopedSlot: 'detail-slot',
        },
      ],
      heapColumns: [
        {
          prop: 'name',
          label: '파일 이름',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'size',
          label: '파일 크기(byte)',
          sortable: true,
          searchable: false,
          formatter: this.getConvertSizeByBData,
        },
        {
          label: '다운로드',
          width: 100,
          headerAlign: 'center',
          align: 'center',
          scopedSlot: 'download-slot',
        },
        {
          label: '삭제',
          width: 100,
          headerAlign: 'center',
          align: 'center',
          scopedSlot: 'delete-slot',
        },
      ],
    };
  },
  computed: mapGetters(['selectedNode']),
  watch: {
    selectedNode: {
      handler() {
        if (!isNil(this.activeTab) && this.activeTab === 'WSnapshotInfoNode') {
          this.initData();
          this.loadData();
        }
      },
      immediate: true,
    },
    activeTab: {
      handler() {
        if (!isNil(this.activeTab) && this.activeTab === 'WSnapshotInfoNode') {
          this.initData();
          this.loadData();
        }
      },
    },
  },
  methods: {
    initData() {
      this.showSearchTool = false;
      this.tableData = [];
    },
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    loadData() {
      const me = this;
      if (this.isLoading === false) {
        this.isLoading = true;
      }
      if (this.dumpType === 'fileDump') {
        ApmConfigAPI.getDumpFileList({ objId: this.selectedNode.obj.objId }).then((response) => {
          if (response.data.success) {
            if (Object.entries(response.data.data).length > 0) {
              me.tableData = response.data.data.values;
            } else {
              me.tableData = [];
            }
          }
          this.isLoading = false;
        });
      } else {
        ApmConfigAPI.getHeapDumpList({ objId: this.selectedNode.obj.objId }).then((response) => {
          if (response.data.success) {
            if (Object.entries(response.data.data).length > 0) {
              this.tableData = response.data.data.values;
            } else {
              this.tableData = [];
            }
          }
          this.isLoading = false;
        });
      }
    },
    /**
     * [changeDumpType 파일덤프/힙덤프 버튼에 따른 리스트를 조회한다.]
     * @author yelim
     */
    changeDumpType() {
      this.initData();
      this.loadData();
    },
    /**
     * [executeDump 선택한 버튼에 따른 덤프를 수행한다.]
     * @author yelim
     */
    executeDump(executeDumpType) {
      const me = this;
      const action = '수행';
      this.$confirm(...msgUtil.getBasicConfirmData(action)).then(() => {
        switch (executeDumpType) {
          case 'active':
            me.activeDump();
            break;
          case 'thread':
            me.threadDump();
            break;
          case 'threadList':
            me.threadListDump();
            break;
          case 'heaphisto':
            me.heapHistoDump();
            break;
          default:
            break;
        }
      }).catch(() => {});
    },
    /**
     * [activeDump [APM 성능/운영 > 구성 > 스냅샷] 액티브 서비스 리스트 덤프를 수행한다.]
     * @author yelim
     */
    activeDump() {
      ApmConfigAPI.executeActiveSvcDump({ objId: this.selectedNode.obj.objId }).then((response) => {
        if (response.data.success) {
          this.loadData();
          this.$message('액티브 서비스 리스트 스냅샷 수행을 완료하였습니다.');
        }
      }).catch(() => {
        this.$message('액티브 서비스 리스트 스냅샷 수행 요청이 실패하였습니다.');
      });
    },
    /**
     * [threadDump [APM 성능/운영 > 구성 > 스냅샷] 쓰레드 덤프를 수행한다.]
     * @author yelim
     */
    threadDump() {
      ApmConfigAPI.executeThreadDump({ objId: this.selectedNode.obj.objId }).then((response) => {
        if (response.data.success) {
          this.loadData();
          this.$message('쓰레드 스냅샷 수행을 완료하였습니다.');
        }
      }).catch(() => {
        this.$message('쓰레드 덤스냅샷프 수행 요청이 실패하였습니다.');
      });
    },
    /**
     * [threadListDump [APM 성능/운영 > 구성 > 스냅샷] 쓰레드 리스트 덤프를 수행한다.]
     * @author yelim
     */
    threadListDump() {
      ApmConfigAPI.executeThreadListDump({ objId: this.selectedNode.obj.objId }).then((response) => {
        if (response.data.success) {
          this.loadData();
          this.$message('쓰레드 리스트 스냅샷 수행을 완료하였습니다.');
        }
      }).catch(() => {
        this.$message('쓰레드 리스트 스냅샷 수행 요청이 실패하였습니다.');
      });
    },
    /**
     * [heapDump [APM 성능/운영 > 구성 > 스냅샷] 힙 덤프를 수행한다.]
     * @author yelim
     */
    onClickHeapDump() {
      const contentTxt = '힙 덤프 생성 요청 시 WAS 서비스에 영향을 줄 수 있습니다.<br />그래도 힙 덤프 수행 요청을 하시겠습니까?';
      this.$confirm(contentTxt, msgUtil.title.CONFIRM, {
        ...msgUtil.defaultConfirmButton,
        dangerouslyUseHTMLString: true,
      }).then(() => {
        ApmConfigAPI.executeHeapDump({ objId: this.selectedNode.obj.objId }).then((response) => {
          if (response.data.success) {
            this.$message('힙 덤프 수행 요청을 전송하였습니다.');
          }
        }).catch(() => {
          this.$message('힙 덤프 수행 요청이 실패하였습니다.');
        });
      }).catch(() => {});
    },
    heapHistoDump() {
      ApmConfigAPI.executeHeapHistoDump({ objId: this.selectedNode.obj.objId }).then((response) => {
        if (response.data.success) {
          this.$message('힙 히스토그램 수행 요청을 전송하였습니다.');
        }
      }).catch(() => {
        this.$message('힙 히스토그램 수행 요청이 실패하였습니다.');
      });
    },
    dumpDownLoad(row) {
      const params = {
        objId: this.selectedNode.obj.objId,
        fileName: row.name,
      };
      this.$emit('load-complete', true);
      ApmConfigAPI.downloadHeapDump(params)
        .then((response) => {
          const blob = new Blob([response.data]);
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = params.fileName;
          link.click();
          link.remove();

          this.$emit('load-complete', false);
        });
    },
    dumpDelete(row) {
      if (!isNil(this.selectionRow)) {
        const params = {
          objId: this.selectedNode.obj.objId,
          fileName: row.name,
        };
        this.$confirm(...msgUtil.getBasicConfirmData(msgUtil.action.DELETE)).then(() => {
          ApmConfigAPI.deleteHeapDump(params).then((response) => {
            if (response.data.success) {
              this.loadData();
            }
            this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, '힙 덤프', response.data.success));
          }).catch(() => {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, '힙 덤프', false));
          });
        }).catch(() => {});
      }
    },
    currentRowChange(row) {
      this.selectionRow = row;
    },
    dateFormmater(row, column, value) {
      return isNil(value) ? EMPTY_TEXT : moment(new Date(value)).format('YYYY-MM-DD HH:mm:ss');
    },
    getConvertSizeByBData(row, column, value) {
      return isNil(value) ? EMPTY_TEXT : convertValuByUnit(value, 'Byte', true, true, true);
    },
    openfileDumpPopup(row) {
      this.fileDumpParams = cloneDeep(row);
      this.$refs.fileDumpPopup.open();
    },
    exportSnapshotInfo() {
      if (this.dumpType === 'fileDump') {
        ApmConfigAPI.getFileSnapshotExcelName({ objId: this.selectedNode.obj.objId }).then((response) => {
          if (response.data.success && !isEmpty(response.data.data)) {
            FileApi.downloadExportedExcelFile(response.data.data);
          }
        });
      } else {
        ApmConfigAPI.getHeapSnapshotExcelName({ objId: this.selectedNode.obj.objId }).then((response) => {
          if (response.data.success && !isEmpty(response.data.data)) {
            FileApi.downloadExportedExcelFile(response.data.data);
          }
        });
      }
    },
    checkSize(size) {
      if (size > 0) {
        return true;
      }
      return false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/config/node/apm/snapshot/index.vue